import { render, staticRenderFns } from "./addTask.vue?vue&type=template&id=bb33a6d2&scoped=true&"
import script from "./addTask.vue?vue&type=script&lang=js&"
export * from "./addTask.vue?vue&type=script&lang=js&"
import style0 from "./addTask.vue?vue&type=style&index=0&id=bb33a6d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb33a6d2",
  null
  
)

export default component.exports